/**
 * Created by A665445 on 28/06/2017.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Master } from './master.model';
import { MasterService } from './master.service';
import { EventManager } from 'ng-jhipster';
import { UtilsService } from '../../shared/utils/utils.service';
import { Subscription } from 'rxjs/Subscription';
import { CampaignService } from '../campaign/campaign.service';

@Component({
    selector: 'jhi-master-referentiel',
    templateUrl: './master-referentiel.component.html'
})
export class MasterReferentielComponent implements OnInit, OnDestroy {

    masters: Master[];
    eventSubscriber: Subscription;
    private subscription: Subscription = new Subscription();

    constructor(
        private masterService: MasterService,
        public utilsService: UtilsService,
        private eventManager: EventManager,
        public campaignService: CampaignService
    ) { }

    ngOnInit() {
        this.loadAll(this.campaignService.getDisplayedCampaign());
        this.registerChangeInMasters();
        this.subscription.add(this.campaignService.notifyObservable$.subscribe((res) => {
            if (res === 'referentiel-masters') {
                this.loadAll(this.campaignService.getDisplayedCampaign());
            }
        }));
    }

    loadAll(campaign: string) {
        this.subscription.add(this.masterService.mgntquery({ 'campaign': campaign }).subscribe(masters => this.masters = masters.json() as Master[]));
    }

    registerChangeInMasters() {
        this.eventSubscriber = this.eventManager.subscribe('masterListModification', (response) => this.loadAll(this.campaignService.getDisplayedCampaign()));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master-referentiel.component.ts